import { env } from 'config';

export const isDev = env === 'dev';
export const isQa = env === 'qa';
export const isStg = env === 'stg';
export const isProd = env === 'prod';



// WEBPACK FOOTER //
// ./client/utils/env.js